import React from 'react';
import './Contact.css';
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa'; // Importation des icônes React Icons

const Contact = () => {
  return (
    <section className="contact">
      <div className="container">
        <h1 className="text-center">Contactez-nous</h1>

        <div className="contact-details mt-5">
          <div className="contact-item">
            <div className="contact-info card">
              <div className="card-body text-center">
                <FaMapMarkerAlt className="fa-3x text-primary mb-3 animated-icon" /> {/* Remplacement de l'icône de localisation */}
                <h3 className="card-title">Siège Social</h3>
                <p className="card-text">
                N'Djamena, 8ème arrondissement
                </p>
              </div>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-info card">
              <div className="card-body text-center">
                <FaPhone className="fa-3x text-success mb-3 animated-icon" /> {/* Remplacement de l'icône de téléphone */}
                <h3 className="card-title">Téléphone</h3>
                <p className="card-text">
                  +235 66284132 |  +235 98929228
                </p>
              </div>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-info card">
              <div className="card-body text-center">
                <FaEnvelope className="fa-3x text-warning mb-3 animated-icon" /> {/* Remplacement de l'icône d'email */}
                <h3 className="card-title">E-mail</h3>
                <p className="card-text">
                  contact&#64;casph-royal.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
